export default "__VITE_ASSET__BQ1WbsdG__"